/* eslint-disable import/no-anonymous-default-export */
import { Buyer } from '../types';
import { BuyersCreate } from './BuyersCreate';
import { BuyersEdit } from './BuyersEdit';
import { BuyersList } from './BuyersList';

export default {
    list: BuyersList,
    create: BuyersCreate,
    edit: BuyersEdit,
    recordRepresentation: (record: Buyer) =>
        `${record.nome_razao}`,
};
